import React from 'react';
import { RaceControlEntry } from '../types';
import './RaceControlPanel.css';

interface RaceControlPanelProps {
  entries: RaceControlEntry[];
}

/** Normalise Apex's data-flag values to a known style bucket. */
function flagClass(flag: string): string {
  switch (flag) {
    case 'penalty':
      return 'rc-penalty';
    case 'warning':
      return 'rc-warning';
    case 'green':
      return 'rc-green';
    case 'msg':
      return 'rc-msg';
    default:
      return 'rc-default';
  }
}

function flagLabel(flag: string): string {
  if (!flag) return 'INFO';
  return flag.toUpperCase();
}

export const RaceControlPanel: React.FC<RaceControlPanelProps> = ({ entries }) => {
  return (
    <div className="rc-panel">
      <div className="rc-header">
        <h3>Race Control</h3>
        <div className="rc-count">{entries.length} entries</div>
      </div>

      <div className="rc-container">
        {entries.length === 0 ? (
          <div className="rc-empty">No race-control messages yet</div>
        ) : (
          entries.map((entry, index) => (
            <div key={index} className={`rc-row ${flagClass(entry.flag)}`}>
              <span className="rc-time">{entry.time || '—'}</span>
              <span className="rc-flag">{flagLabel(entry.flag)}</span>
              {entry.kartNumber ? (
                <span
                  className={`rc-kart${entry.category ? ` rc-kart--${entry.category}` : ''}`}
                >
                  {entry.kartNumber}
                </span>
              ) : (
                <span className="rc-kart rc-kart--none" />
              )}
              <span className="rc-text">{entry.text}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default RaceControlPanel;
